import React, { useState } from "react";
import useMessageInput from "./useMessageInput";
import withWidth, { isWidthUp } from "@material-ui/core/withWidth";
import { isString, isEmpty } from "lodash";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import axios from "axios";

import { ReplyMessageContext } from "../../context/ReplyingMessage/ReplyingMessageContext";
import { ForwardMessageContext } from "../../context/ForwarMessage/ForwardMessageContext";
import { AuthContext } from "../../context/Auth/AuthContext";
import { useLocalStorage } from "../../hooks/useLocalStorage";
import toastError from "../../errors/toastError";
import { toast } from "react-toastify";

import Compressor from 'compressorjs';


import useQuickMessages from "../../hooks/useQuickMessages";
import useFiles from "../../hooks/useFiles";
import logger from "../../utils/logger";
import MediaPreviewPanel from "./components/MediaPreviewPanel";
import useAudioRecorder from "./hooks/useAudioRecorder";
import useAttachmentHandlers from "./hooks/useAttachmentHandlers";
import useAgentPresence from "./hooks/useAgentPresence";
import NormalInputView from "./components/NormalInputView";
import ContactPickerModal from "./components/ContactPickerModal";
import ServiceWindowNotice from "./components/ServiceWindowNotice";
import useServiceWindow from "./hooks/useServiceWindow";
import WabaTemplateModal from "../WabaTemplateModal";

/** 0293 B: caché firma interna — evita GET por cada envío; TTL sesión (tab). */
const MessageInputCustom = (props) => {

  const { ticketStatus, ticketId, ticket, width, pendingDropFiles, onPendingDropFilesHandled } = props; // width: withWidth — menú compacto en móvil
  const isMobileCompact = !isWidthUp("sm", width);

  const messageInputApi = useMessageInput(props);

  // 0367 (H8): ventana de servicio de 24h (WABA). Hooks antes de cualquier return
  // condicional para respetar las reglas de hooks.
  const { needsTemplate } = useServiceWindow({ ticketId });
  const [templateModalOpen, setTemplateModalOpen] = useState(false);

  // useMessageInput devuelve JSX (MediaPreviewPanel) cuando hay adjuntos en preview;
  // en ese caso se renderiza directamente (no es el objeto de handlers del input normal).
  if (React.isValidElement(messageInputApi)) {
    return messageInputApi;
  }

  // Ventana cerrada: se prohíbe el texto libre y solo se puede iniciar con plantilla.
  if (needsTemplate) {
    return (
      <>
        <ServiceWindowNotice onOpenTemplates={() => setTemplateModalOpen(true)} />
        <WabaTemplateModal
          open={templateModalOpen}
          onClose={() => setTemplateModalOpen(false)}
          ticketId={ticketId}
          whatsappId={ticket?.whatsappId}
          onSent={() => setTemplateModalOpen(false)}
        />
      </>
    );
  }

  const {
    _handleCancelAudio,
    _handleStartRecording,
    _handleUploadAudio,
    activeMediaIndex,
    addFiles,
    analyserRef,
    blocked,
    closeMobileComposerMenu,
    contactPickerModal,
    contactPickerOpen,
    disableOption,
    fileListAnchorEl,
    fileListOptions,
    fileLists,
    getFileType,
    handleAddEmoji,
    handleCancelAll,
    handleCancelAudio,
    handleChangeMedias,
    handleDragEnter,
    handleDragLeave,
    handleDragOver,
    handleDrop,
    handleFileListButtonClick,
    handleFileListClick,
    handleFileListMenuClose,
    handleFileListSelect,
    handleInputPaste,
    handleMediaCaptionPaste,
    handleOpenModalForward,
    handleQuickAnswersClick,
    handleQuickReplyButtonClick,
    handleRemoveMedia,
    handleSelectActiveMedia,
    handleSendMessage,
    handleSendVcard,
    handleStartRecording,
    handleUploadAudio,
    handleUploadMedia,
    handleUploadQuickMessageMedia,
    inputMessage,
    inputRef,
    isAIAgent,
    isAIBlocked,
    isDragOver,
    isMessageInputBlocked,
    isPending,
    listFiles,
    listQuickMessages,
    loading,
    mediaCaptionInputRef,
    mediaCaptions,
    medias,
    mobileComposerMenuAnchor,
    mobileFabRef,
    mobilePickAudio,
    mobilePickContact,
    mobilePickDocument,
    mobilePickPhotoVideo,
    notifyRecordingStart,
    notifyRecordingStop,
    notifyReset,
    notifyTyping,
    options,
    pendingTextJobsRef,
    popupOpen,
    prevInputLenRef,
    quickMessages,
    recording,
    replyingMessage,
    resetAttachments,
    runTextSendJob,
    selectedMessages,
    sendingText,
    setActiveMediaIndex,
    setContactPickerOpen,
    setFileListAnchorEl,
    setFileListOptions,
    setFileLists,
    setForwardMessageModalOpen,
    setInputMessage,
    setLoading,
    setMediaCaptions,
    setMedias,
    setMobileComposerMenuAnchor,
    setOptions,
    setPopupOpen,
    setQuickMessages,
    setReplyingMessage,
    setSelectedMessages,
    setSendingText,
    setShowEmoji,
    setShowSelectMessageCheckbox,
    setSignMessage,
    setUploadProgress,
    showEmoji,
    showSelectMessageCheckbox,
    signMessage,
    textDrainChainRef,
    uploadProgress,
    user,
    validateFileSize,
  } = messageInputApi;

  return (
    <>
      {contactPickerModal}
    <NormalInputView
      blocked={blocked}
      isPending={isPending}
      isAIBlocked={isAIBlocked}
      replyingMessage={replyingMessage}
      setReplyingMessage={setReplyingMessage}
      isMobileCompact={isMobileCompact}
      width={width}
      isDragOver={isDragOver}
      handleDragOver={handleDragOver}
      handleDragEnter={handleDragEnter}
      handleDragLeave={handleDragLeave}
      handleDrop={handleDrop}
      mobileFabRef={mobileFabRef}
      mobileComposerMenuAnchor={mobileComposerMenuAnchor}
      setMobileComposerMenuAnchor={setMobileComposerMenuAnchor}
      closeMobileComposerMenu={closeMobileComposerMenu}
      mobilePickDocument={mobilePickDocument}
      mobilePickPhotoVideo={mobilePickPhotoVideo}
      mobilePickAudio={mobilePickAudio}
      mobilePickContact={mobilePickContact}
      showEmoji={showEmoji}
      setShowEmoji={setShowEmoji}
      handleAddEmoji={handleAddEmoji}
      disableOption={disableOption}
      handleChangeMedias={handleChangeMedias}
      handleQuickReplyButtonClick={handleQuickReplyButtonClick}
      handleFileListButtonClick={handleFileListButtonClick}
      handleFileListMenuClose={handleFileListMenuClose}
      handleFileListSelect={handleFileListSelect}
      fileListAnchorEl={fileListAnchorEl}
      fileListOptions={fileListOptions}
      signMessage={signMessage}
      setSignMessage={setSignMessage}
      loading={loading}
      sendingText={sendingText}
      recording={recording}
      inputMessage={inputMessage}
      setInputMessage={setInputMessage}
      inputRef={inputRef}
      ticketStatus={ticketStatus}
      handleSendMessage={handleSendMessage}
      handleInputPaste={handleInputPaste}
      handleQuickAnswersClick={handleQuickAnswersClick}
      options={options}
      popupOpen={popupOpen}
      handleCancelAudio={handleCancelAudio}
      handleUploadAudio={handleUploadAudio}
      handleStartRecording={handleStartRecording}
      analyserRef={analyserRef}
      handleOpenModalForward={handleOpenModalForward}
      showSelectMessageCheckbox={showSelectMessageCheckbox}
      setShowSelectMessageCheckbox={setShowSelectMessageCheckbox}
      setSelectedMessages={setSelectedMessages}
      onContactPick={() => setContactPickerOpen(true)}
    />
    </>
  );
};

export default withWidth()(MessageInputCustom);

